import { useEffect, useState } from 'react';
import Utils from '@/common/utils/utils';
import { I18n } from 'aws-amplify';
import { Typography } from '@material-ui/core';
import ListTagFieldDropDown from './ListTagFieldDropDown';
import ListItemOfSelectedTagField from './ListItemOfSelectedTagField';
import ListItemSingleChoice from './ListItemSingleChoice';
import ListItemOfPrivateBookmark from './ListItemOfPrivateBookmark';
import LoadingPanel from '@/component/common/LoadingPanel';
import './ListItemTagField.css';

function RenderTagFieldInForm(props) {
    const [isShowListItemOfTagField, setIsShowListItemOfTagField] = useState(false);
    const [selectedTagField, setSelectedTagField] = useState({});
    const [listTagItem, setListTagItem] = useState([]);

    useEffect(() => {
        if (!Utils.isEmptyArray(props.listTagFieldOfForm)) {
            setSelectedTagField(props.listTagFieldOfForm[0]);
        }
    }, [props.listTagFieldOfForm]);

    return (
        <div className="multi_public-range-action render-tag-field-in-form">
            <LoadingPanel isLoading={props.loadingBulkItemListTagField} />
            <div className="multi_public-range-action-left">
                <span className="option-name label-multi-public-range">
                    <p style={{ fontWeight: '550' }}>{I18n.get('EIDT_TAG_ITEM_FIELD')}</p>
                </span>
                <span className="option-name label-multi-public-range">
                    <p>{I18n.get('SELECT_TAG_FIELD')}</p>
                </span>
            </div>

            <div className="multi_public-range-action-right">
                <div className="share-status-cancel">
                    <Typography
                        className="btn-cancel-share-public-range"
                        variant="contained"
                        onClick={e => props?.setIsShowEditTagField(false)}
                    >
                        <span>{I18n.get('COMBTN001')}</span>
                    </Typography>
                </div>
                <div className="group-edit-public-range">
                    <ListTagFieldDropDown
                        selectedTagField={selectedTagField}
                        listTagFieldOfForm={props.listTagFieldOfForm}
                        setSelectedTagField={setSelectedTagField}
                        setListTagItem={setListTagItem}
                    />
                    <div
                        className={`icon-edit-public-range ${
                            isShowListItemOfTagField ? ' show-list-role' : ''
                        } ${
                            !Utils.isEmptyObject(selectedTagField) ? 'enable' : 'disable-icon-edit'
                        }`}
                    >
                        {!Utils.isEmptyObject(selectedTagField) ? (
                            selectedTagField.isBookmark ? (
                                <ListItemOfPrivateBookmark
                                    listTagItem={listTagItem}
                                    setIsShowListItemOfTagField={setIsShowListItemOfTagField}
                                    drillDownData={props.drillDownData}
                                    selectedTagField={selectedTagField}
                                    totalTickets={props.totalTickets}
                                    currentSearchParams={props.currentSearchParams}
                                    setIsShowEditTagField={props.setIsShowEditTagField}
                                    setIsOpenAlertDialog={props.setIsShowDialogReload}
                                    setIsShowDialogNotiLimit={props.setIsShowDialogNotiLimit}
                                    setMsgInProcessingIcon={props.setMsgInProcessingIcon}
                                    action={props.action}
                                    selectedFormId={props.selectedFormId}
                                />
                            ) : (
                                <>
                                    {selectedTagField?.isMultiple ? (
                                        <ListItemOfSelectedTagField
                                            listTagItem={listTagItem}
                                            setIsShowListItemOfTagField={
                                                setIsShowListItemOfTagField
                                            }
                                            drillDownData={props.drillDownData}
                                            selectedTagField={selectedTagField}
                                            totalTickets={props.totalTickets}
                                            currentSearchParams={props.currentSearchParams}
                                            setIsShowEditTagField={props.setIsShowEditTagField}
                                            setIsOpenAlertDialog={props.setIsShowDialogReload}
                                            setIsShowDialogNotiLimit={
                                                props.setIsShowDialogNotiLimit
                                            }
                                            msgInProcessingIcon={props.msgInProcessingIcon}
                                            setMsgInProcessingIcon={props.setMsgInProcessingIcon}
                                            action={props.action}
                                            selectedFormId={props.selectedFormId}
                                        />
                                    ) : (
                                        <ListItemSingleChoice
                                            listTagItem={listTagItem}
                                            setIsShowListItemOfTagField={
                                                setIsShowListItemOfTagField
                                            }
                                            drillDownData={props.drillDownData}
                                            selectedTagField={selectedTagField}
                                            totalTickets={props.totalTickets}
                                            currentSearchParams={props.currentSearchParams}
                                            setIsShowEditTagField={props.setIsShowEditTagField}
                                            setIsShowDialogNotiLimit={
                                                props.setIsShowDialogNotiLimit
                                            }
                                            msgInProcessingIcon={props.msgInProcessingIcon}
                                            setMsgInProcessingIcon={props.setMsgInProcessingIcon}
                                            action={props.action}
                                            selectedFormId={props.selectedFormId}
                                            setIsOpenAlertDialog={props.setIsShowDialogReload}
                                        />
                                    )}
                                </>
                            )
                        ) : (
                            <Typography className="" variant="contained">
                                <img
                                    src="/assets/image/edit-setting-public-url.svg"
                                    alt="icon-edit-range"
                                    className="disable-icon-edit-img"
                                />
                            </Typography>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RenderTagFieldInForm;
